export const OverTimePolicyAmountValueTypeConstant = [
    { name: "Flat hourly rate", value: "flat" },
    { name: "Multiplied by hourly rate", value: "multiplied" },
    { name: "Extra added with hourly rate", value: "extra_added_with_hourly_rate" },
    { name: "Extra added with monthly salary", value: "extra_added_with_monthly_salary" },
];
